import { Layout } from '@/modules/shared/layouts/layout'

import { useScheduleForm } from '../hooks/use-schedule-form.hook'
import { ScheduleFormInterface } from '../interfaces/schedule-form.interface'

export function ScheduleFormContainer() {
  const scheduleFormHook = useScheduleForm()
  return (
    <Layout
      pageTitle={
        scheduleFormHook.selectedSchedule?.idAgendamento
          ? 'Editar agendamento'
          : 'Novo agendamento'
      }
      handleGoBack={scheduleFormHook.handleGoBack}
    >
      <ScheduleFormInterface {...scheduleFormHook} />
    </Layout>
  )
}
